<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        class="filter-item"
        v-model="listQuery.hotel_code"
        placeholder="酒店编码"
        style="width: 220px"
        clearable
        size="small"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.room_code"
        placeholder="房型编码"
        style="width: 220px"
        clearable
        size="small"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.policy_id"
        placeholder="政策ID"
        style="width: 220px"
        clearable
        size="small"
      />
      <el-button
        class="filter-item"
        type="primary"
        @click="handleFilter"
        size="small"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column label="ID" min-width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="酒店编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_code }}
        </template>
      </el-table-column>

      <el-table-column label="房型编码" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_code }}
        </template>
      </el-table-column>

      <el-table-column label="政策ID" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.policy_id }}
        </template>
      </el-table-column>

      <el-table-column label="政策名称" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.policy_name }}
        </template>
      </el-table-column>

      <el-table-column label="品牌名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.brand_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="销售价" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.sales_price }}
        </template>
      </el-table-column>

      <el-table-column label="平均价" min-width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.avg_price || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="支付类型" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.pay_type === 1" type="success">预付</el-tag>
          <el-tag v-else-if="scope.row.pay_type === 2" type="warning">到付</el-tag>
          <span v-else>{{ scope.row.pay_type_name || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="早餐" min-width="100" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.breakfast === 2" type="info">无早</el-tag>
          <el-tag v-else-if="scope.row.breakfast === 3">单早</el-tag>
          <el-tag v-else-if="scope.row.breakfast === 4" type="success">双早</el-tag>
          <el-tag v-else-if="scope.row.breakfast === 5" type="warning">三早</el-tag>
          <el-tag v-else-if="scope.row.breakfast === 6" type="danger">四早</el-tag>
          <span v-else>{{ scope.row.breakfast_name || '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column label="最大入住人数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_person || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="最小预订量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.min_amount || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="最大预订量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.max_amount || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="是否需要更新" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_need_update === 1" type="warning">是</el-tag>
          <el-tag v-else type="success">否</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[5, 10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        hotel_code: '',
        room_code: '',
        policy_id: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/suiChuan/hotel/policyList',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.items
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped></style>
